import React from 'react';
import ReactDOMServer from "react-dom/server";
import { locHtml } from "../locHtml";

const allSet = (t: (key: string) => string) => <div className="new-quote-container centered">
  <div className="splash-icon">🎉</div>
  <div className="splash-header">
    <h1 className="no-word-break">{t("splash.gymBuddy.allSet.title")}</h1>
    <div className="quote">{t("splash.gymBuddy.allSet.text")}</div>
  </div>
</div>;

const allSetElement = {
  name: 'training-circle',
  type: 'html',
  html: locHtml((t) => ReactDOMServer.renderToStaticMarkup(allSet(t))),
}

export default allSetElement;
